import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/Navbar.css';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null); // Reference to the menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const closeMenuOnLinkClick = () => {
    setIsMenuOpen(false); // Close the menu when any link is clicked
  };

  return (
    <nav className='navbar'>
      <button className="mobile-menu-button" onClick={toggleMenu}>
        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>
      <h1 className='logo'>Kgpian.tech</h1>
      <div
        className={`links ${isMenuOpen ? 'active' : ''}`}
        ref={menuRef} // Attach the ref to the menu
      >
        <span className='link'> <Link to="/" className='tabs' onClick={closeMenuOnLinkClick}>Home</Link></span>
        <span className='link'> <Link to="/about" className='tabs' onClick={closeMenuOnLinkClick}>About</Link></span>
        <span className='link'> <Link to="/services" className='tabs' onClick={closeMenuOnLinkClick}>Services</Link></span>
        <span className='link'> <Link to="/projects" className='tabs' onClick={closeMenuOnLinkClick}>Projects</Link></span>
        <span className='link'> <Link to="/contact" className='tabs' onClick={closeMenuOnLinkClick}>Contact</Link></span>
        <span className='link'> <Link to="/careers" className='tabs' onClick={closeMenuOnLinkClick}>Careers</Link></span>
      </div>
    </nav>
  );
};

export default Navbar;
